module.exports = __webpack_public_path__ + "static/media/add-filter-icon.ed95b973.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add-filter-icon.svg
// module id = 59
// module chunks = 0